<script>
  import {
    editDefaultBannerStatus,
    getBannerDefaultPage,
    getBannerDetail
  } from '../../../api/bottomBannerDefault'
  import { getBannerPosition, getStatusMap } from './config/format'
  import DefaultBanner from './components/DefaultBanner.vue'
  import BannerDetail from './components/banner-detail.vue'
  import RejectDialog from './components/RejectDialog.vue'

  export default {
    name: 'bottomBanner',
    components: { DefaultBanner, BannerDetail, RejectDialog },
    data() {
      return {
        searchFormItems: [
          {
            type: 'el-input',
            label: '广告名称',
            prop: 'name'
          },
          {
            type: 'select',
            label: '状态',
            prop: 'status',
            options: getStatusMap({}, true)
          },
          {
            type: 'el-input',
            label: '创建人',
            prop: 'createUser'
          }
        ],
        initVals: {
          name: '',
          status: '',
          createUser: ''
        },
        records: [],
        // 分页
        pagination: {
          total: 5,
          current: 1,
          pageSize: 10
        },
        loading: false,
        // 用于记录需要合并的行
        spanArray: [], // 简化为单个数组记录第一列的合并情况
        query: {},
        editVisible: false,
        infoData: null,
        detailVisible: false,
        currentDetailId: null,
        currentBanner: null,
        rejectDialogVisible: false
      }
    },
    created() {
      // 初始化数据
      // this.fetchData()
    },
    methods: {
      getBannerPosition,
      handleSearch(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.fetchData()
      },
      handleReset(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.fetchData()
      },
      handleAdd() {
        this.infoData = null
        this.editVisible = true
      },
      onTableChange({ current, pageSize }) {
        // 分页改变后的逻辑
        this.pagination.pageSize = pageSize
        this.pagination.current = current
        this.fetchData()
      },
      fetchData() {
        console.log('9999', this.pagination)
        const params = {
          ...this.query,
          size: this.pagination.pageSize,
          current: this.pagination.current
        }
        this.loading = true
        getBannerDefaultPage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              const { records = [], total = 0 } = data || {}
              // 对数据按模板名称分组排序，确保相同模板的数据连续显示
              // 1. 首先按adTemplateName分组
              const groupByTemplate = {}
              records.forEach((item) => {
                const template = item.adTemplateName || ''
                if (!groupByTemplate[template]) {
                  groupByTemplate[template] = []
                }
                groupByTemplate[template].push(item)
              })

              // 2. 计算每个组的排序权重（使用组内第一条记录的位置）
              const groupWeights = {}
              Object.keys(groupByTemplate).forEach((template) => {
                // 找出该组第一条记录在原始数组中的位置作为权重
                groupWeights[template] = records.findIndex((r) => r.adTemplateName === template)
              })

              // 3. 按组权重排序并合并结果
              const sortedRecords = []
              Object.keys(groupByTemplate)
                .sort((a, b) => groupWeights[a] - groupWeights[b])
                .forEach((template) => {
                  sortedRecords.push(...groupByTemplate[template])
                })

              this.records = sortedRecords
              this.pagination.total = total || 0
            }
          })
          .finally(() => {
            this.loading = false
          })
      },

      // 处理单元格合并
      handleSpanMethod({ row, column, rowIndex, columnIndex }) {
        // 只处理第一列的合并
        if (columnIndex === 0) {
          // 如果是第一行，需要向下找所有相同模板名的行
          if (rowIndex === 0) {
            let count = 1
            for (let i = 1; i < this.records.length; i++) {
              if (this.records[i].adTemplateName === row.adTemplateName) {
                count++
              } else {
                break
              }
            }
            return { rowspan: count, colspan: 1 }
          }

          // 非第一行，检查与上一行是否相同
          const prevRow = this.records[rowIndex - 1]
          if (prevRow && prevRow.adTemplateName === row.adTemplateName) {
            // 与上一行相同模板，隐藏此单元格
            return { rowspan: 0, colspan: 0 }
          } else {
            // 与上一行不同，需要计算向下有多少个相同模板的行
            let count = 1
            for (let i = rowIndex + 1; i < this.records.length; i++) {
              if (this.records[i].adTemplateName === row.adTemplateName) {
                count++
              } else {
                break
              }
            }
            return { rowspan: count, colspan: 1 }
          }
        }

        // 其他列不合并
        return { rowspan: 1, colspan: 1 }
      },

      // 渲染状态标签
      renderStatusTag(status) {
        const statusMap = {
          0: { type: 'warning', text: '草稿' },
          1: { type: 'primary', text: '待审核' },
          2: { type: 'danger', text: '未通过' },
          4: { type: 'success', text: '已启用' },
          5: { type: 'info', text: '已下架' }
        }

        return statusMap[status] || { type: '', text: status }
      },

      closeDialog() {
        this.fetchData()
      },

      changeStatus(status, row) {
        const { id } = row
        if (status === 2) {
          // 不通过，打开拒绝弹窗
          this.currentBanner = row
          this.rejectDialogVisible = true
          return
        }

        const stateMap = {
          1: '确定通过审核吗？',
          4: '下架后不再展示该广告！',
          3: ''
        }

        const tipMap = {
          4: '确定下架吗',
          3: '确定上架吗'
        }

        const httpFunc = () => {
          editDefaultBannerStatus({
            id,
            op: status
          }).then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success('操作成功！')
              this.fetchData()
            }
          })
        }

        if (stateMap[status] || stateMap[status] === '') {
          this.$confirm(stateMap[status], tipMap[status] || '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '稍后再看',
            type: 'warning',
            center: true
          }).then(() => {
            httpFunc()
          })
        } else {
          httpFunc()
        }
      },

      onDelete(row) {
        this.$confirm('是否确认删除，确认后删除已保存的草稿数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeStatus(5, row)
        })
      },

      editBanner(row) {
        const { id } = row
        getBannerDetail(id).then((res) => {
          const { code, data } = res
          if (code === 0) {
            const {
              auditTime,
              auditUserName,
              createTime,
              createUserName,
              rejectReason,
              updateTime,
              updateUserName,
              ...rest
            } = data
            this.infoData = {
              isEdit: true,
              ...rest
            }
            this.editVisible = true
          }
        })
      },

      viewDetail(row) {
        this.currentDetailId = row.id
        this.$nextTick(() => {
          this.$refs.bannerDetail.init(row.id)
        })
      },

      // 处理拒绝确认
      handleRejectConfirm(data) {
        editDefaultBannerStatus({
          id: data.id,
          op: 2,
          refuseReason: data.reason
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('已拒绝审核')
            this.rejectDialogVisible = false
            this.fetchData()
          }
        })
      }
    }
  }
</script>

<template>
  <basic-container>
    <YDSearchForm
      :form-items="searchFormItems"
      :initial-values="initVals"
      @search="handleSearch"
      @reset="handleReset"
      @add="handleAdd"
      permi="user_advertising_edit"
    />
    <yd-table
      ref="advertisingTable"
      :data="records"
      :pagination="pagination"
      :loading="loading"
      @onChange="onTableChange"
      :span-method="handleSpanMethod"
    >
      <el-table-column label="模板" prop="adTemplateName" align="center" />
      <el-table-column label="名称" prop="name" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="viewDetail(scope.row)">{{ scope.row.name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="banner位置" prop="slotKey" align="center">
        <template slot-scope="scope">
          {{ getBannerPosition({ slotKey: scope.row.slotKey }) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center">
        <template slot-scope="scope">
          <el-tag :type="renderStatusTag(scope.row.status).type" size="small">
            {{ renderStatusTag(scope.row.status).text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUserName" align="center" />
      <el-table-column label="创建时间" prop="createTime" align="center" />
      <el-table-column label="操作" prop="operate" align="center" width="180">
        <template slot-scope="scope">
          <!--          除去已启用状态都可编辑-->
          <el-button
            type="text"
            size="mini"
            class="edit-button"
            v-if="scope.row.status !== 4"
            @click="editBanner(scope.row)"
            v-has-permi="['user_advertising_edit']"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            v-if="scope.row.status === 0"
            @click="changeStatus(0, scope.row)"
            v-has-permi="['user_advertising_submitAudit']"
            >提交审核</el-button
          >
          <el-button
            type="text"
            size="mini"
            v-if="scope.row.status === 1"
            @click="changeStatus(1, scope.row)"
            v-has-permi="['user_advertising_review']"
            >通过</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="danger-button"
            v-if="scope.row.status === 1"
            @click="changeStatus(2, scope.row)"
            v-has-permi="['user_advertising_review']"
            >不通过</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="danger-button"
            v-if="scope.row.status === 4"
            @click="changeStatus(4, scope.row)"
            v-has-permi="['user_advertising_status']"
            >下架</el-button
          >
          <el-button
            type="text"
            size="mini"
            v-if="scope.row.status === 5"
            @click="changeStatus(3, scope.row)"
            v-has-permi="['user_advertising_status']"
            >上架</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="danger-button"
            v-if="scope.row.status === 0"
            @click="onDelete(scope.row)"
            v-has-permi="['user_advertising_delete']"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </yd-table>
    <DefaultBanner
      v-if="editVisible"
      :visible.sync="editVisible"
      v-model="infoData"
      @closeDialog="closeDialog"
    />
    <BannerDetail ref="bannerDetail" />
    <RejectDialog
      :visible.sync="rejectDialogVisible"
      :bannerId="currentBanner ? currentBanner.id : ''"
      @confirm="handleRejectConfirm"
    />
  </basic-container>
</template>

<style scoped lang="scss">
  .danger-button {
    color: #f56c6c;
  }
  .edit-button {
    color: #5688fc;
  }
</style>
